import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import networkExplorer from './assets/network-explorer.png'
import networkExplorer2x from './assets/network-explorer@2x.png'
import networkExplorerMobile from './assets/network-explorer-mobile.png'
import networkExplorerMobile2x from './assets/network-explorer-mobile@2x.png'
import Topic from '~shared/Topic'
import Display from '~shared/Display'
import ButtonWrapper from '~shared/ButtonWrapper'
import urls from '~utils/urls'

const Image = styled.div`
    border-radius: 4px;
    margin-bottom: 2.5rem;
    max-height: 224px;
    overflow: hidden;

    img {
        width: 100%;
    }
`

const Inner = styled.div`
    margin: 0 auto;
    max-width: 912px;
    position: relative;

    @media (min-width: ${DESKTOP}px) {
        max-width: 1160px;
    }
`

const BackgroundImage = styled.img`
    height: auto;
    width: 100%;
`

const ContentWrap = styled.div`
    @media (min-width: ${TABLET}px) {
        align-items: center;
        display: flex;
        flex-direction: row;
        height: 100%;
        justify-content: flex-end;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

const Content = styled.div`
    ${Topic.Title} {
        text-align: left;
        margin: 0;
    }

    ${Topic.Paragraph} {
        margin: 1.25rem 0 2.5rem;
    }

    @media (min-width: ${TABLET}px) {
        display: flex;

        ${Topic.Paragraph} {
            margin: 1.25rem 0 1.5rem;
        }
    }
`

const Pusher = styled.div`
    @media (min-width: ${TABLET}px) {
        flex-grow: 1;
        flex-shrink: 1;
    }
`

const ContentInner = styled.div`
    @media (min-width: ${TABLET}px) {
        box-sizing: border-box;
        padding: 0 80px 0 40px;
        width: 580px;
    }
`

const UnstyledExploreNetwork = (props) => (
    <div {...props} $appear>
        <Inner>
            <Display
                as={Image}
                mobile
                tablet="none"
            >
                <img
                    alt=""
                    src={networkExplorerMobile}
                    srcSet={`${networkExplorerMobile2x} 2x`}
                />
            </Display>
            <Display
                alt=""
                as={BackgroundImage}
                height="720"
                mobile="none"
                src={networkExplorer}
                srcSet={`${networkExplorer2x} 2x`}
                tablet
                width="1160"
            />
            <ContentWrap>
                <Content>
                    <Pusher />
                    <ContentInner>
                        <Topic.Title $appear>
                            Explore the Network
                        </Topic.Title>
                        <Topic.Paragraph $appear>
                            The Network Explorer app allows you to dig into what is happening moment-to-moment on the Streamr Network.
                            View and search for nodes, streams and connections, with live and historical metrics.
                        </Topic.Paragraph>
                        <ButtonWrapper>
                            <Button
                                tag="a"
                                kind="primary"
                                size="big"
                                href={urls.apps.networkExplorer}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                Launch the app
                            </Button>
                        </ButtonWrapper>
                    </ContentInner>
                </Content>
            </ContentWrap>
        </Inner>
    </div>
)

const ExploreNetwork = styled(UnstyledExploreNetwork)`
    padding: 0 16px;

    @media (min-width: ${TABLET}px) {
        padding: 0 32px;
    }
`

export default ExploreNetwork
